
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.09 31.71v-8.27a2.92 2.92 0 10-5.84 0v8.27M27.75 31.71v-8.27a2.92 2.92 0 10-5.84 0v8.27M1.33 32.69h37.34","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M38.67 15.56V38.5H1.33V15.56M7.47 32.51V4.42M32.53 32.51V4.42M4 5.46a40.61 40.61 0 0132 .13"}}),_c('path',{attrs:{"d":"M23.47 10.16a3.48 3.48 0 00-6.94 0H1.33v5.4h37.34v-5.4z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    